import { Navigate, Route, Routes } from 'react-router-dom';
import { useAuth } from '../providers/AuthProvider.js';
import { TabLayout } from './TabLayout.js';
import { HomeScreen } from '../screens/HomeScreen.js';
import { ProjectsScreen } from '../screens/ProjectsScreen.js';
import { ProjectEditorScreen } from '../screens/ProjectEditorScreen.js';
import { CreateProjectScreen } from '../screens/CreateProjectScreen.js';
import { PremiumScreen } from '../screens/PremiumScreen.js';
import { GuideScreen } from '../screens/GuideScreen.js';
import { AdminPaymentsScreen } from '../screens/AdminPaymentsScreen.js';
import { SettingsScreen } from '../screens/SettingsScreen.js';
import { AdminScreen } from '../screens/AdminScreen.js';
import { ChannelsScreen } from '../screens/ChannelsScreen.js';

/** Application routes. Tab screens share the bottom nav; the editor is full-screen. */
export function MainRouter(): JSX.Element {
  const { hasPermission } = useAuth();
  const canAdmin = hasPermission('admin:access');

  return (
    <Routes>
      <Route element={<TabLayout />}>
        <Route path="/" element={<HomeScreen />} />
        <Route path="/projects" element={<ProjectsScreen />} />
        <Route path="/settings" element={<SettingsScreen />} />
        <Route
          path="/admin"
          element={canAdmin ? <AdminScreen /> : <Navigate to="/" replace />}
        />
      </Route>
      <Route path="/projects/new" element={<CreateProjectScreen />} />
      <Route path="/projects/:id" element={<ProjectEditorScreen />} />
      <Route path="/premium" element={<PremiumScreen />} />
      <Route path="/guide" element={<GuideScreen />} />
      <Route
        path="/admin/payments"
        element={canAdmin ? <AdminPaymentsScreen /> : <Navigate to="/" replace />}
      />
      <Route path="/channels" element={<ChannelsScreen />} />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}
